import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import { connectRoutes } from 'redux-first-router'

/* redux-first-router */
import history from 'routing/history'
import routesMap from 'routing/routesMap/index'
import options from 'routing/options'

/* reducers */
import reducers from 'reducers'

const {
  reducer,
  middleware,
  enhancer
} = connectRoutes(history, routesMap, options)

const rootReducer = combineReducers({
  ...reducers,
  location: reducer
})
const middlewares = applyMiddleware(middleware)

const store = createStore(rootReducer, compose(enhancer, middlewares))

export default store



// WEBPACK FOOTER //
// ./src/store.js